import { BitrixVue, reactive } from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { VplRouter } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { CatalogCard } from 'vpl.tas';

export const CatalogRecom = {
    components: {
        ItemEditBtns,
        CatalogCard
    },
    props: {
        structKey: [String, Number]
    },
    updated(){

    },
    mounted(){
        if($('.js-recommend-slider').length){
            let SwiperRecommend = new Swiper('.js-recommend-slider', {
                loop: true,
                lazyPreloadPrevNext: 2,
                grabCursor: true,
                slidesPerView: 4,
                spaceBetween: 20,
                // autoplay: {
                //   delay: 3000,
                // },
                navigation: {
                nextEl: ".js-recommend-next",
                prevEl: ".js-recommend-prev"
                },
                breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 8
                },
                576: {
                    slidesPerView: 2.4,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                1200: {
                    slidesPerView: 4,
                    spaceBetween: 20
                }
                }
            });
        }
    },
    methods: {

    },
    computed: {
        ...mapState(vplSiteStore, ['templateData', 'struct', 'title'])
    },
    template: `

<section v-if="this.struct[this.structKey].componentData.ITEMS && Object.values(this.struct[this.structKey].componentData.ITEMS).some(item => item && item.STOCK_STATUS_CODE !== 'discontinued')" class="section section--beg recommend">
    <div class="container">
        <div class="section__heading">
            <div class="section__title-wp">
                <h2 class="section__title">
					Рекомендуем
                </h2>
                <div class="section__nav-arrows">
                    <div class="swiper-button-prev slider-btn js-recommend-prev">
                        <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                    </div>
                    <div class="swiper-button-next slider-btn js-recommend-next">
                        <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                    </div>
                </div>
            </div>
        </div>
        <div class="swiper recommend-slider js-recommend-slider">
            <div class="swiper-wrapper">

                <div v-for="item in Object.values(this.struct[this.structKey].componentData.ITEMS).filter(item => item && item.STOCK_STATUS_CODE !== 'discontinued')" class="swiper-slide">
                    <CatalogCard :item="item"/>
                </div>

            </div>
        </div>
    </div>
</section>
    `
}